import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const hourLabel = (h) => {
  const x = ((h % 24) + 24) % 24;
  return `${x % 12 || 12}${x < 12 ? "am" : "pm"}`;
};

export const slotLabel = (s, plural = true) =>
  `${DAYS[s.day]}${plural ? "s" : ""} ${hourLabel(s.hour)}–${hourLabel(s.hour + 1)}`;

export function useBusyAlerts(active, pollMs = 0) {
  const [data, setData] = useState(null);
  const load = useCallback(() => {
    if (!active) return;
    api.get("/media-buyer/busy-alerts").then((r) => setData(r.data)).catch(() => {});
  }, [active]);
  useEffect(() => {
    load();
    if (!active || !pollMs) return undefined;
    const t = setInterval(load, pollMs);
    return () => { clearInterval(t); };
  }, [load, active, pollMs]);
  return { data, setData, reload: load };
}
